export default {
  loyalty:
    'Мен RC Group серіктестерінің <a target="_blank" href="{link}">адалдық бағдарламасының</a> шарттарын қабылдаймын',
  posOferta:
    'Мен RC POS сервисінің <a target="_blank" href="https://cdn.rc.today/storage/partners/common/docs/ru/pos/Договор%20о%20присоединении%20к%20RC%20POS.pdf">шартын</a> қабылдаймын',
  1: "Негізгі ақпарат",
  2: "Жеке ақпарат",
  3: "Заңды тұлға",
  haveAcc: "Аккаунтыңыз бар ма?",
  login: "Кіру",

  mainInfo: {
    title: "Негізгі ақпарат",
    promocode: "Промокод",
    country: "Ел",
    phone: "Телефон нөмірі",
    checkbox:
      " Жеке деректерімді өңдеуге келісім беремін\n" +
      "<a download href='{link}'>Құпиялылық саясатына</a> сәйкес",
    oferta:
      "Мен шарттарды қабылдаймын" + " <a download href='{link}'>Оферта</a>",
  },

  profileInfo: {
    title: "Жеке ақпарат",
    firstName: "Аты",
    lastName: "Тегі",
    middleName: "Әкесінің аты",
    email: "Пошта",
    password: "Құпиясөз",
    confPassword: "Құпиясөзді қайталаңыз",
    registerCode: "Поштадағы код",
    notSendCode: "Код келмеді ме?",
    sendAgain: "Қайта жіберу",
  },

  emailCode: {
    title: "Растау коды сіздің поштаңызға жіберілді",
    subtitle:
      'Егер "{mail}" мекенжайына хат келмесе, «Спам» қалтасын тексеріңіз',
    emailCode: "Поштадағы код",
    sendAgainTime: "Кодты қайта жіберу уақыты: ",
    dontSend: "Код келмеді ме?",
    sendAgain: "Қайта жіберу",
  },

  entity: {
    title: "Заңды тұлға",
    subTitle:
      "«Келесі» батырмасын баспас бұрын енгізілген деректерді тексеріп шығыңыз",
    entityType: "Заңды тұлға түрі",
    halalCertificate: "Заңды тұлғаның Халал сертификаты бар",
    fileType: "PNG, JPG, PDF - 1 файл, 10 Мб дейін",
    commercial: "Коммерциялық",
    checkbox: "Заңды тұлға кәсіпкерлік қызметпен айналысады",
  },

  payment: {
    title: "Тіркелгеніңізге рахмет!",
    subtitle:
      "Енді сіз RC Group адалдық бағдарламасының жеке кабинетіне кіре аласыз.",
    moderation:
      "Қазіргі уақытта сіздің заңды тұлға модерациядан өтуде. Әдетте тексеру 24-тен 48 сағатқа дейін уақыт алады",
    examination:
      "Тексеруден өту үшін сіз көрсетілген заңды тұлғадан шотты төмендегі батырма арқылы жүктеп алып, төлеуіңіз керек. Сондай-ақ шотты жеке кабинетте таба аласыз: «Менің кәсіпорындарым» — «Құжаттар» бөлімінде «Тестік төлем» атауымен.",

    goToCabinet: "Жеке кабинетке өту",
    alternativeCheck: {
      button: "Альтернативті тексеруден өту",
      description:
        "Сізге «Анкета-өтініш» құжатын жүктеп алып, қол қойып, мөр басып, компания поштасына жіберу қажет болады.",
    },
  },

  alternativePayment: {
    title: "Егер шотты төлеу мүмкіндігі болмаса",
    signDocAndSendToMail:
      "Тексеруден өту үшін төмендегі батырма арқылы құжатты жүктеп алып, қол қойып, осы бетке жүктеуіңіз немесе <b>hello@rc.city</b> поштасына жіберуіңіз қажет",
    whereIsDoc:
      "Сондай-ақ құжатты жеке кабинеттен таба аласыз: «Менің кәсіпорындарым» — «Құжаттар» бөлімінде «Заңды тұлғаны растау анкетаcы» атауымен",
    downloadFileName: "Анкета-өтініш",
    useMainCheckWay: "Тексеруден өтудің негізгі тәсілін қолдану",
    paymentInvoice: "Төлем шоты",
  },
};
